import styled from 'styled-components';

export const StyledInlineMessages = styled.div``;
